import axios from 'axios';
import trueApiURL from './url.helper';


export default function request({
  headers, body, method, url,
}) {
  const apiURL = trueApiURL(url);

  const fetchOptions = {
    crossDomain: true,
    method,
    mode: 'cors',
    body,
    headers,
    cache: 'no-store',
  };

  const axiosOptions = {
    url: apiURL,
    method,
    headers,
    // cache: 'no-store',
    data: body,
  };
  return new Promise((resolve, reject) => axios(axiosOptions)
    .then(response => (response.status !== 200 ? reject(response) : response))
    .then(response => response)
    .then(response => resolve(response.data))
    .catch((error) => { reject(error); }));
}

export function authRequest(params) {
  let headers = {};

  const token = localStorage.getItem('token');
  if (token) {
    headers = { Authorization: `Bearer ${token}` };
  }
  return request({ ...params, headers });
}
